import firebase from "firebase";
import { AppString } from "./modules/Chat/Component/Const";
import { myFirebase, myFirestore } from "./modules/Chat/Config/firebase";
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import moment from "moment";
import { v1 as uuidv1 } from 'uuid';
const adapter = new LocalStorage("db");
const db = low(adapter);

const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    myFirebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(async (result) => {
        let user = result.user;
        if (user) {
          const result = await myFirestore
            .collection(AppString.NODE_USERS)
            .where(AppString.ID, "==", user.uid)
            .get();

          if (result.docs.length === 0) {
            // Set new data since this is a new user
            myFirestore
              .collection("users")
              .doc(user.uid)
              .set({
                id: user.uid,
                email : email,
                nickname: name === "" ? user.displayName : name,
                aboutMe: "",
                photoUrl: user.photoURL,
              })
              .then((data) => {
                // Write user info to local
                localStorage.setItem(AppString.ID, user.uid);
                localStorage.setItem(AppString.NICKNAME, user.displayName);
                localStorage.setItem(AppString.PHOTO_URL, user.photoURL);
              });
            await fetchPushToken(
              user.uid,
              localStorage.getItem(AppString.PUSH_TOKEN)
            );
          } else {
            // Write user info to local
            localStorage.setItem(AppString.ID, result.docs[0].data().id);
            localStorage.setItem(
              AppString.NICKNAME,
              result.docs[0].data().nickname
            );
            localStorage.setItem(
              AppString.PHOTO_URL,
              result.docs[0].data().photoUrl
            );
            localStorage.setItem(
              AppString.ABOUT_ME,
              result.docs[0].data().aboutMe
            );
            await fetchPushToken(
              result.docs[0].data().id,
              localStorage.getItem(AppString.PUSH_TOKEN)
            );
          }
        } else {
          console.log("User info not available");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (err) {
    console.error("err", err);
  }
};
function FetchTokenApi(id, token) {
  var myHeaders = new Headers();
  const tokenServer = db.read().getState()?.Token;
  myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);
  myHeaders.append("Content-Type", `application/json`);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({
      Token: token,
      UserId: id,
    }),
    redirect: "follow",
  };
  if (tokenServer !== null && tokenServer !== undefined && tokenServer !== "") {
    fetch(`${window.$apiurl}/api/Account/setFirebaseToken`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
       console.log(result);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

}
const updateProfilePicture = async (link, name) => {
  try {
    const id = localStorage.getItem(AppString.ID);
    const result = await myFirestore
      .collection(AppString.NODE_USERS)
      .where(AppString.ID, "==", id)
      .get();
    if (result.docs.length > 0) {
      const currentData = await myFirestore
        .collection(AppString.NODE_LOADS)
        .where('shipperId', "==", id)
        .get();
      if (currentData?.docs?.length > 0) {
        currentData.forEach((s) => {
          myFirestore
            .collection("loads")
            .doc(`${s?.data()?.id}-${s?.data()?.userId}-${s?.data()?.shipperId}`)
            .update({
              nickname: name,
              photoUrl: link ?? "",
            });
        });
      }
      myFirestore
        .collection("users")
        .doc(id)
        .update({
          photoUrl: link,
          nickname: name,
        })
        .then((data) => {
          localStorage.setItem(AppString.PHOTO_URL, link);
          localStorage.setItem(AppString.NICKNAME, name);
        });
    }
  } catch (err) {
    console.error("err", err);
  }
};
async function fetchPushToken(id, token) {
  try {
    const result = await myFirestore
      .collection(AppString.NODE_USERS)
      .where(AppString.ID, "==", id)
      .get();

    const nickname = localStorage.getItem(AppString.NICKNAME);
    const photoUrl = localStorage.getItem(AppString.PHOTO_URL);
    if (result.docs.length > 0) {
      myFirestore
        .collection("users")
        .doc(id)
        .update({
          pushToken: token,
          nickname: nickname,
          photoUrl : photoUrl
        })
        .then((data) => {
          localStorage.setItem(AppString.PUSH_TOKEN, token);
        });
    }

    //fetch api token
    FetchTokenApi(id, token);
  } catch (err) {
    console.error("err", err);
  }
}

async function fetchDataToggle(id, data) {
  try {
    console.log('ddd',data);
    let dataPost = {
      loadCode: data.loadCode,
      header : data.header,
      message: data.message,
      idFrom: data.idFrom,
      idTo: data?.idTo,
      date: data?.date,
      timestamp: data?.timestamp,
      peerNickname :  data?.peerNickname,
      shipperToken : data?.shipperToken,
      type : !!data?.type ? data?.type : "",
      loadId : !!data?.loadId ? data?.loadId : "",
      photoUrl : data?.photoUrl ?? ""
    };
    // console.log('id',id);
    // console.log('dataPost',dataPost);
      myFirestore
        .collection(AppString.NODE_NOTIFICATIONS)
        .doc(id)
        .set({
          loadCode: dataPost.loadCode ?? "",
          header: dataPost.header ?? "",
          message: dataPost.message ?? "",
          shipId: dataPost.idFrom ?? "",
          truckerId: dataPost.idTo ?? "",
          date: dataPost.date ?? "",
          timestamp: dataPost.timestamp ?? "",
          shipperNickname: dataPost?.peerNickname ?? "",
          shipperToken: dataPost?.shipperToken,
          photoUrl: dataPost?.photoUrl ?? "",
          id: dataPost.idTo ?? "",
          type : dataPost?.type,
          loadId : dataPost?.loadId?.toString()
        })
        .then((data) => {
          // localStorage.setItem(AppString.NODE_NOTIFICATIONS, dataPost);
        });

  } catch (err) {
    console.error("err", err);
  }
}

async function FetchNotifyTrucker(firebaseId, data, code) {
  if (!!firebaseId === false) {
    return false;
  }
  const currentUserId = localStorage.getItem(AppString.ID);
  const currentNickName = localStorage.getItem(AppString.NICKNAME);
  let currentPeerUser = await myFirestore
    .collection(AppString.NODE_USERS)
    .where(AppString.ID, "==", firebaseId)
    .get();
  if (currentPeerUser.length === 0) return false;
  var resultUser = currentPeerUser.docs[0];
  currentPeerUser = {
    id: resultUser.data().id,
    pushToken: resultUser.data().pushToken,
    nickname: resultUser.data().nickname,
    photoUrl: resultUser.data().photoUrl,
  };
  // console.log("currentPeerUser", currentPeerUser);

  //send notification
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `key=${process.env.REACT_APP_SERVER_KEY}`);
  var title = `Shipper (${currentNickName}) accepted the Load# (${code}) for the bid ($${data?.Price}).`;
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({
      to: currentPeerUser?.pushToken,
      notification: {
        body: "",
        title: title,
        sound: "default",
      },
      apns: {
        headers: {
          "apns-priority": "10",
        },
        payload: {
          aps: {
            sound: "default",
          },
        },
      },
      android: {
        priority: "high",
        notification: {
          sound: "default",
        },
      },
      data: {
        id: data?.Id,
        loadCode: code,
        type: "accept_bid",
      },
    }),
    redirect: "follow",
  };

  fetch("https://fcm.googleapis.com/fcm/send", requestOptions)
    .then((response) => response.text())
    .then(async (response) => {
      const res = await response;
      if (res.status === 200) {
        console.log("res.body");
      }
      return false;
    })
    .then((res) => {
      if (res?.Code === "400") {
        return false;
      }
      //Save Notification list
      fetchDataToggle(
        `${currentUserId}-${currentPeerUser?.id}-${uuidv1().toString()}`,
        {
          type: "accept_bid",
          loadId : data?.ShipmentId,
          header: title,
          message: "",
          loadCode: code,
          idFrom: currentUserId,
          idTo: currentPeerUser.id,
          date: moment(new Date()).format("MM-DD-YYYY hh:mm a"),
          timestamp: moment()
            .valueOf()
            .toString(),
          peerNickname: currentPeerUser.nickname,
          shipperToken: currentPeerUser?.pushToken,
          photoUrl: currentPeerUser?.photoUrl,
        }
      );
    });
}
const logInWithEmailAndPassword = async (email, password) => {
  try {
    myFirebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async (result) => {
        let user = result.user;
        if (user) {
          const result = await myFirestore
            .collection(AppString.NODE_USERS)
            .where(AppString.ID, "==", user.uid)
            .get();

          // Write user info to local
          localStorage.setItem(AppString.ID, result.docs[0].data().id);
          localStorage.setItem(
            AppString.NICKNAME,
            result.docs[0].data().nickname
          );
          localStorage.setItem(
            AppString.PHOTO_URL,
            result.docs[0].data().photoUrl
          );
          localStorage.setItem(
            AppString.ABOUT_ME,
            result.docs[0].data().aboutMe
          );
          await fetchPushToken(
            user.uid,
            localStorage.getItem(AppString.PUSH_TOKEN)
          );
        } else {
          console.log("User info not available");
        }
        //update pushToken
      })
      .catch(async (err) => {
        if (err.code === "auth/user-not-found") {
          await registerWithEmailAndPassword(email, email, `pass-${email?.replace(' ', '')}`);
        }
        console.log('err',err);
      });
  } catch (err) {
    console.error(err);
  }
};

const sendPasswordReset = async (email) => {
  try {
    await firebase.auth().sendPasswordResetEmail(email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  firebase.auth().signOut();
};
export {
  registerWithEmailAndPassword,
  logInWithEmailAndPassword,
  updateProfilePicture,
  sendPasswordReset,
  logout,
  fetchDataToggle,
  fetchPushToken,
  FetchNotifyTrucker
};
